<template>
  <div>
    <d-row no-gutters>
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/logos/logo-partner.svg"
              alt="Shards Dashboards - Login Template"
              style="max-width: 9rem"
            />
            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">Acesse sua conta</h5>
            <div>
              <!-- Form Fields -->
              <d-form>
                <ValidationObserver ref="validationForm">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required|email"
                      v-slot="{ errors, invalid }"
                    >
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        v-model="login.Email"
                        :disabled="loading"
                        @keyup.enter="AuthenticateValidation($event)"
                        type="email"
                        placeholder="E-mail"
                      />
                      <div
                        class="invalid-feedback d-block"
                        v-if="validatedForm"
                      >
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors, invalid }"
                    >
                      <d-input
                        ref="passwordField"
                        :class="validatedForm | showValidateError(invalid)"
                        v-model="login.Password"
                        :disabled="loading"
                        @keyup.enter.native="AuthenticateValidation($event)"
                        type="password"
                        placeholder="Senha"
                      />
                      <div
                        class="invalid-feedback d-block"
                        v-if="validatedForm"
                      >
                        {{ errors[0] }}
                      </div>
                    </ValidationProvider>
                  </div>
                  <!-- <div class="form-group mb-3 d-table mx-auto">
                    <d-checkbox value="remember">Lembrar meus dados</d-checkbox>
                  </div> !-->
                  <b-button
                    pill
                    v-on:click.stop="AuthenticateValidation($event)"
                    class="btn-accent d-table mx-auto"
                    :disabled="loading"
                  >
                    <template v-if="!loading">ENTRAR</template>
                    <template v-else>
                      <b-spinner small v-if="loading"></b-spinner>
                    </template>
                  </b-button>
                </ValidationObserver>
              </d-form>
            </div>
          </d-card-body>
        </d-card>

        <!-- Meta Details -->
        <div class="auth-form__meta d-flex mt-4">
          <d-link tag="a" to="forgot-password" class="mx-auto"
            >Esqueceu sua senha?</d-link
          >
        </div>
      </d-col>
    </d-row>
  </div>
</template>

<script>
const Fingerprint2 = require("fingerprintjs2");
import Vue from "vue";

export default {
  name: "login",
  data: function () {
    return {
      loading: false,
      validatedForm: false,
      login: {
        Email: null,
        Password: null,
      },
    };
  },
  computed: {},
  mounted() {
    var auth = this.$getAuth();
    if (auth != null) {
      this.$router.push({ name: "dashboard" });
    }
    sessionStorage.setItem("NotificationIsReaded", false);

    let autologout = sessionStorage.getItem("sessionExpired");
    sessionStorage.removeItem("sessionExpired");

    if (autologout) autologout = "sessionExpired";

    let error = this.$route.query.error;
    let info = this.$route.query.info;
    if (error || info || autologout) {
      let identificator = error ? error : info ? info : autologout;
      let msg = null;
      switch (identificator) {
        case "credentialsNeeded":
          msg = "Você precisa se autenticar para acessar esse recurso.";
          break;
        case "sessionExpired":
          msg = "Sua sessão expirou, faça login novamente para continuar.";
          break;
        case "sessionFinished":
          msg = "Você foi desconectado com sucesso!";
          break;
      }
      if (msg) this.$makeToast(msg, "info", "");
    }

    const email = this.$route.query.email;
    if (email) {
      this.login.Email = email;
      this.$refs.passwordField.$el.focus();
    }
  },
  methods: {
    AuthenticateValidation: function (e) {
      e.preventDefault();
      this.validatedForm = true;
      this.$refs.validationForm.validate().then((valid) => {
        if (valid) {
          this.Authenticate();
        }
      });
    },
    Authenticate: function () {
      this.loading = true;
      this.$store
        .dispatch("Authenticate", this.login)
        .then((response) => {
          //requestIdleCallback(() => {
          Fingerprint2.getV18((result) => {
            this.$setFingerprint(result);
          });
          //});
          this.$setAuth(response);

          const nextUrl = sessionStorage.getItem("nextUrl");
          sessionStorage.removeItem("nextUrl");
          if (nextUrl) {
            window.location.href = nextUrl;
          } else {
            if (this.$profileCode() == "1")
              this.$router.push({ name: "dashboard" });
            else this.$router.push({ name: "partners-merchant" });
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível autenticar o usuário.",
            "danger",
            "Autenticação de Usuário",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/login.vue